<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">

        <div class="card o-hidden border-0 shadow-lg mt-5">
          <div class="card-body p-0">
            <div class="row">
              <div
                v-if="$constant.APP === 'SINERGI'"
                class="col-lg-6 d-none d-lg-block bg-login-image"
                style="background-image: url('/images/banner/logo-siapman.jpg');">  
              </div>

              <div
                  v-if="$constant.APP === 'SIAPMAN'"
                  class="col-lg-6 d-none d-lg-block bg-login-image"
                  style="background-image: url('/images/banner/logo-siapman.jpg'); 
                        background-size: cover; 
                        background-position: center center; 
                        background-repeat: no-repeat;">
              </div>

              <div class="col-lg-6">
                <div class="p-5">
                  <div class="text-center">
                    <div v-if="$constant.APP === 'SINERGI'">
                      <img src="/images/logo/rsud.png" style="width:100px; margin-bottom:10px;"/>

                      <h1 class="h3 text-gray-900 mb-2">
                        <strong>SINERGI</strong>
                      </h1>
                      <hr>
                      <h2 class="h4 text-gray-900 mb-4 d-none d-lg-block ">
                        <strong class="text-primary">S</strong>ISTEM
                        <strong class="text-primary">IN</strong>FORMASI
                        T<strong class="text-primary">ER</strong>INTE<strong class="text-primary">G</strong>RAS<strong class="text-primary">I</strong>
                      </h2>
                    </div>

                    <div v-if="$constant.APP === 'SIAPMAN'">
                      <img src="/images/logo/siapman.png" style="width:100px; margin-bottom:10px;"/>

                      <h1 class="mb-0 pb-0">
                        <strong>SIAPMAN</strong>
                      </h1>
                      <hr>
                      <h2 class="h5 text-gray-900 mb-4 d-none d-lg-block ">
                        <strong class="text-primary">S</strong>istem
                        <strong class="text-primary">I</strong>ntegrasi<br>
                        <strong class="text-primary">A</strong>bsensi
                        <strong class="text-primary">P</strong>egawai
                        dengan e-perfor<strong class="text-primary">man</strong>ce
                      </h2>
                    </div>

                  </div>

                  <form class="user" @submit.prevent="onSubmit">
                    <div class="form-group">
                      <input type="text" v-model="form.username" class="form-control" placeholder="Username">
                    </div>
                    <div class="form-group">
                      <input type="password" v-model="form.password" class="form-control" placeholder="Password">
                    </div>
                    <button type="submit" class="btn btn-primary btn-block">
                      Login
                    </button>
                  </form>
                  <hr>

                  <div class="mt-4 text-center">
                      <a href="https://play.google.com/store/apps/details?id=id.go.lamongankab.siapman" target="_blank">
                          <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" 
                              style="width:100px; margin-bottom:10px;"/>
                      </a>
                      <a href="#">
                          <img class="ml-2" src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Download_on_the_App_Store_Badge.svg/135px-Download_on_the_App_Store_Badge.svg.png" 
                              style="width:100px; margin-bottom:10px;"/>
                      </a>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        username: '',
        password: ''
      }
    }
  },

  methods: {
    onSubmit () {
      const formData = new FormData()

      formData.append('username', this.form.username)
      formData.append('password', this.form.password)

      this.$axios.post('/login',
        formData,
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(res => {
        if (res.data.token) {
          this.$store.commit('user/successLogin', res.data)
        }

      })
    }
  }
}
</script>